module.exports = __webpack_public_path__ + "static/media/iep-userflow02.ada555f1.png";